export const aboutLinks = [
  { id: 1, link: "Main Skills" },
  { id: 2, link: "Experience" },
  { id: 3, link: "Education & Certificate" },
];

export const aboutDetails = [
  [
    {
      id: 1,
      title: "Front-End Developer",
      extraTitle: "",
      description: "JavaScript, React, Redux, HTML5, CSS3, Bootstrap",
    },
    {
      id: 2,
      title: "Back-End Developer",
      extraTitle: "",
      description: "Ruby,Ruby on Rails, postgreSql, MySQL, SQL Server",
    },
    {
      id: 3,
      title: "Professional",
      extraTitle: "",
      description:
        "Remote collaboration, Pair-Programming, cross-communication,Teamwork, Mentoring, Agile Methodologies, Git, GitHub, TDD, Mobile/Responsive Development, VsCode, Chrome Dev Tools",
    },
  ],
  [
    {
      id: 1,
      title: " Mentor (Volunteer)",
      extraTitle: " - MICROVERSE  · Full-time",
      description:
        "January, 2022,- Present , Mentored junior web developers, providing technical support through code reviews,  Proposed improvements to code organization to improve code quality and overall performance, Provided advice and tips on how to maintain motivation to maintain longevity in the program.",
    },
    {
      id: 2,
      title: " Integrated Financial Management System (IFMS) specialist",
      extraTitle:
        " - Independent Directorate of Local Governance (IDLG) · Full-time",
      description:
        "Jun 2019 - November 2021  ,Financial Management System Development ,  Performed Surveys and System based assessment, municipality data gathering, manipulation and analyzing for IFMS in IDLG  ",
    },
  ],
  [
    {
      id: 1,
      title: "Remote Full Stack Web Development Program, Full-Time",
      extraTitle: " - Microverse",
      description:
        "2022 Spent 1300+ hours mastering algorithms, data structures, and full-stack development while, simultaneously developing projects with Ruby, Ruby on Rails, JavaScript, React, and Redux, Developed skills in remote pair-programming using GitHub, industry-standard git-flow, and daily,standups to communicate and collaborate with international remote developers.",
    },
    {
      id: 2,
      title: "Bachelor's degree Computer Software Engineering, Full-Time",
      extraTitle: " - Kabul polytchnic Unisersity(KPU)",
      description: "2015",
    },
  ],
];

export default "Working";
